module.exports = __webpack_public_path__ + "img/voiscooter.50590d3f.jpg";